import { render, staticRenderFns } from "./CiblesTimelinePage.vue?vue&type=template&id=2c56a12e&"
import script from "./CiblesTimelinePage.vue?vue&type=script&lang=js&"
export * from "./CiblesTimelinePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports